import { createSelector } from '@reduxjs/toolkit';

export const selectFolders = createSelector(
  [
    (state) => state.folders.folders,
    (state) => state.folders.privateFolders,
    (state) => state.folders.selectedFolderId,
    (state) => state.folders.loading
  ],
  (folders, privateFolders, selectedFolderId, loading) => ({ folders, privateFolders, selectedFolderId, loading })
);

export const selectBreadcrumbs = createSelector(
  [(state) => state.folders.selectedFolderId, (state) => state.folders.breadcrumbs],
  (selectedFolderId, breadcrumbs) => ({ selectedFolderId, breadcrumbs })
);
